var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const Svg3Pie4 = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Salida-datos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "inicio-selecci\\xF3n-multiple-de-eventos-copy-17",
    transform: "translate(-1248.000000, -139.000000)",
    fill: "#939393"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1255.70874,153.477865 L1255.70927,157.000096 C1251.89431,156.451635 1248.84751,153.507876 1248.12335,149.732145 L1251.6735,149.732092 C1252.27024,151.589516 1253.80086,153.02471 1255.70874,153.477865 Z M1258.29173,156.999953 L1258.29227,153.477626 C1260.19976,153.024189 1261.72999,151.589076 1262.32657,149.73187 L1265.87668,149.732018 C1265.15262,153.507482 1262.10627,156.451118 1258.29173,156.999953 Z M1255.70927,138.999904 L1255.70874,142.522135 C1253.51346,143.043552 1251.81766,144.865156 1251.46931,147.134132 L1247.99994,147.134267 C1248.39303,142.94903 1251.60704,139.589664 1255.70927,138.999904 Z M1258.29173,139.000047 C1262.3935,139.590209 1265.60704,142.949403 1266.00007,147.134332 L1262.53071,147.134246 C1262.18246,144.865563 1260.4871,143.044116 1258.29227,142.522374 L1258.29173,139.000047 Z",
    id: "Combined-Shape"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg3Pie4, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/3_Pie4.d7843be4.svg";
export { ForwardRef as ReactComponent };